import React, { useEffect } from "react";
import { Form, FormElement } from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import moment from "moment";
import { Typography } from "@progress/kendo-react-common";
import AlertBox from "../../../components/common/AlertBox";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { getAllTop10RetailerReport } from "../services/reports.services";
import { LoadingPanel } from "../../../components/layout/Loading";
import { clearTop10RetailerReportList } from "../reportsSlice";
import {
  calculateTotalRow,
  createChunks,
  formatIndianNumber,
  getUnitTypes,
  reconstructData,
} from "../../../_helper/helper";
import { sumBy } from "lodash";
import ButtonWithLoading from "../../../components/common/ButtonWithLoading";

const Top10RetailerReport: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = JSON.parse(
    sessionStorage.getItem("top10retailerreportState") || "{}"
  );
  // const initialValues = JSON.parse(JSON.stringify(state.initialValues));

  const setPrintStyles = () => {
    const style = document.createElement("style");
    style.type = "text/css";
    style.innerHTML = `
      @media print {
        @page {
          margin-left: 0.5cm;
          margin-right: 0.5cm;
        }
        .toptenretailerreport-print-break{
          page-break-before: always;
          }
          .toptenretailerreport-break-inside{
           break-inside: avoid;
    page-break-inside: avoid;
          }
      }
    `;
    document.head.appendChild(style);
  };

  const Top10RetailerReportList = useAppSelector(
    (state) => state.reports.Top10RetailerReportList
  );
  const loading = useAppSelector((state) => state.reports.loading);
  const gridRef = React.useRef<any>(null);
  const fetchReport = async () => {
    const payload = {
      from_date: state?.from_date,
      to_date: state?.to_date,
      orderby: state?.orderby,
      distributors_id: state?.distributors_id,
    };
    const res = await dispatch(getAllTop10RetailerReport(payload));
    if (res.meta.requestStatus === "fulfilled") {
      setPrintStyles();
      setTimeout(() => {
        window.print();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleTabClose = () => {
      sessionStorage.removeItem("top10retailerreportState");
    };
    fetchReport();
    return () => {
      window.removeEventListener("unload", handleTabClose);
      dispatch(clearTop10RetailerReportList());
    };
  }, []);

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      {Top10RetailerReportList.map((list: any, index: number) => (
        <div
          className={`${index > 0 ? "toptenretailerreport-print-break" : ""}`}
        >
          <Top10RetailerReportTable list={list} />
        </div>
      ))}
    </>
  );
};

interface RetailerReportProps {
  list: any; // Replace `any` with the actual expected type
}
const Top10RetailerReportTable: React.FC<RetailerReportProps> = ({ list }) => {
  const state = JSON.parse(
    sessionStorage.getItem("top10retailerreportState") || "{}"
  );

  const initialValues = { distributor_name: "" };
  // This function retrun me which item have how many unit type
  const Top10RetailerList = list?.retailer_list;
  const unitArray = getUnitTypes(Top10RetailerList);

  // This function create chunk of checking unittype
  const distributorChunks = createChunks(unitArray, 7);

  // This funtion return tables accouding distributorChunks
  const DistributorWiseList = distributorChunks.map((item: any) => {
    return reconstructData(item, Top10RetailerList);
  });

  // const checkInclude = (key: string, formRenderProps: FormRenderProps) => {
  //   return formRenderProps.valueGetter("filter_columns")?.includes(key);
  // };
  return (
    <>
      {Top10RetailerList && Top10RetailerList.length ? (
        <Form
          initialValues={initialValues}
          render={() => {
            return (
              <FormElement style={{ width: "100%" }}>
                <GridLayout
                  //   style={{ marginRight: 30 }}
                  gap={{ rows: 10, cols: 10 }}
                  cols={[{ width: "100%" }]}
                >
                  <ButtonWithLoading
                    buttonStyle={{
                      position: "fixed",
                      right: 20,
                      top: 20,
                      zIndex: 100,
                    }}
                    label={"Print"}
                    className="no-visible-print-btn"
                    type="button"
                    onClick={() => window.print()}
                  />
                  <GridLayoutItem className="d-flex justify-content-between align-items-center">
                    <Typography.h5 className="m-0 text-center w-100">
                      Top 10 Retailer Report
                      <>
                        <p style={{ fontSize: 16 }}>
                          {state.orderby == 1 && (
                            <>
                              {" "}
                              For City :-{" "}
                              {Top10RetailerList?.[0]?.city_name?.toUpperCase()}{" "}
                            </>
                          )}
                          {state.orderby == 2 && (
                            <>
                              {" "}
                              For State :-{" "}
                              {Top10RetailerList?.[0]?.state_name?.toUpperCase()}{" "}
                            </>
                          )}
                          {state.orderby == 3 && (
                            <>
                              {" "}
                              For Distributor :-{" "}
                              {Top10RetailerList?.[0]?.distributor_name?.toUpperCase()}{" "}
                            </>
                          )}
                          For Period :-
                          {state.from_date &&
                            state.to_date &&
                            `( ${moment(state.from_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} - ${moment(state.to_date, "YYYY-MM-DD").format(
                              "DD/MM/YYYY"
                            )} )`}
                        </p>
                      </>
                    </Typography.h5>
                  </GridLayoutItem>
                  <GridLayoutItem>
                    {DistributorWiseList.length > 0 ? (
                      DistributorWiseList?.map(
                        (retailerlist: any, index: number) => {
                          const unitArrayType =
                            retailerlist?.[0].unitTypes?.[0];
                          return (
                            <table
                              cellSpacing={1}
                              cellPadding={2}
                              className={`table table-bordered salesmanwisereport-print ${
                                index > 0
                                  ? "salesmanwisereport-print-break"
                                  : ""
                              }`}
                              style={{
                                width: "fit-content",
                              }}
                            >
                              <thead>
                                <tr
                                  className="text-center fw-600"
                                  style={{
                                    fontSize: 12,
                                  }}
                                >
                                  <th style={{ minWidth: 50 }} rowSpan={2}>
                                    SR. No
                                  </th>
                                  <th style={{ minWidth: 100 }} rowSpan={2}>
                                    Retailer Name
                                  </th>
                                  <th style={{ minWidth: 100 }} rowSpan={2}>
                                    City
                                  </th>
                                  <th style={{ minWidth: 100 }} rowSpan={2}>
                                    State
                                  </th>
                                  <th style={{ minWidth: 100 }} rowSpan={2}>
                                    Distributor Name
                                  </th>
                                  <th style={{ minWidth: 100 }} rowSpan={2}>
                                    Total
                                  </th>
                                  {unitArrayType?.map(
                                    (item_group: any, index: any) => (
                                      <th
                                        key={index}
                                        colSpan={item_group.unitTypes?.length}
                                      >
                                        {item_group.item_group?.toUpperCase()}{" "}
                                        GROUP
                                      </th>
                                    )
                                  )}
                                </tr>

                                <tr
                                  className="text-center fw-600"
                                  style={{
                                    fontSize: 12,
                                  }}
                                >
                                  {/* Dynamically Generate Unit and Value Headers */}
                                  {unitArrayType.map(
                                    (group: any, groupIndex: number) => (
                                      <React.Fragment key={groupIndex}>
                                        {group?.unitTypes?.map(
                                          (unit: string, unitIdx: number) => (
                                            <React.Fragment key={unitIdx}>
                                              <th style={{ minWidth: 100 }}>
                                                {unit}
                                              </th>
                                              {/* <th style={{ minWidth: 100 }}>
                                            Value
                                          </th> */}
                                            </React.Fragment>
                                          )
                                        )}
                                        {/* <th style={{ minWidth: 100 }}>Total</th> */}
                                      </React.Fragment>
                                    )
                                  )}
                                </tr>
                              </thead>

                              {/* Table Body */}

                              <tbody>
                                {retailerlist.map(
                                  (item: any, rowIndex: number) => {
                                    const totalItemGroups = Array.from(
                                      new Set(
                                        retailerlist.flatMap((entry: any) =>
                                          entry.item_groups
                                            ?.filter(
                                              (item: any) =>
                                                item.item_data?.length > 0
                                            )
                                            .map(
                                              (group: any) => group.item_group
                                            )
                                        )
                                      )
                                    );

                                    return (
                                      <>
                                        <tr
                                          key={rowIndex}
                                          className="toptenretailerreport-break-inside"
                                        >
                                          <td>{rowIndex + 1}</td>
                                          <td>{item?.retailer_name}</td>
                                          <td>{item?.city_name}</td>
                                          <td>{item?.state_name}</td>
                                          <td>
                                            {item?.distributor_name?.toUpperCase()}
                                          </td>
                                          <td className="text-end">
                                            {formatIndianNumber(
                                              item.total_amount
                                            )}
                                          </td>
                                          {totalItemGroups.map((_, index) => {
                                            const groupData = item?.item_groups
                                              ?.filter(
                                                (item: any) =>
                                                  item.item_data?.length > 0
                                              )
                                              ?.find(
                                                (group: any) =>
                                                  group.item_group ===
                                                  totalItemGroups[index]
                                              );
                                            const units =
                                              unitArrayType[index].unitTypes ||
                                              [];

                                            return (
                                              <>
                                                {units.map((unit: string) => {
                                                  const qtyKey =
                                                    unit === "KG"
                                                      ? "unit_kg_qty"
                                                      : unit === "PACKET"
                                                      ? "unit_pkt_qty"
                                                      : "unit_bdh_qty";
                                                  // const amtKey =
                                                  //   unit === "KG"
                                                  //     ? "unit_kg_amt"
                                                  //     : unit === "PACKET"
                                                  //     ? "unit_pkt_amt"
                                                  //     : "unit_bdh_amt";

                                                  return (
                                                    <React.Fragment key={unit}>
                                                      <td
                                                        style={{
                                                          textAlign: "end",
                                                        }}
                                                      >
                                                        {groupData
                                                          ?.item_data[0][qtyKey]
                                                          ? groupData?.item_data[0][
                                                              qtyKey
                                                            ]?.toFixed(2)
                                                          : 0}
                                                      </td>
                                                      {/* <td
                                                  style={{
                                                    textAlign: "end",
                                                  }}
                                                >
                                                  {groupData?.item_data[0][
                                                    amtKey
                                                  ]
                                                    ? groupData?.item_data[0][
                                                        amtKey
                                                      ]?.toFixed(2)
                                                    : 0}
                                                </td> */}
                                                    </React.Fragment>
                                                  );
                                                })}

                                                {/* <td style={{ textAlign: "end" }}>
                                            {units
                                              .reduce(
                                                (
                                                  total: number,
                                                  unit: string
                                                ) => {
                                                  const amtKey =
                                                    unit === "KG"
                                                      ? "unit_kg_amt"
                                                      : unit === "PACKET"
                                                      ? "unit_pkt_amt"
                                                      : "unit_bdh_amt";
                                                  return (
                                                    total +
                                                    (groupData?.item_data[0][
                                                      amtKey
                                                    ] || 0)
                                                  );
                                                },
                                                0
                                              )
                                              .toFixed(2)}
                                          </td> */}
                                              </>
                                            );
                                          })}
                                        </tr>
                                      </>
                                    );
                                  }
                                )}
                                <tr
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "lightgrey",
                                  }}
                                >
                                  <td
                                    colSpan={5}
                                    style={{ fontWeight: "bold" }}
                                  >
                                    Final Total
                                  </td>
                                  <td style={{ textAlign: "end" }}>
                                    {formatIndianNumber(
                                      sumBy(retailerlist, "total_amount")
                                    )}
                                  </td>
                                  {Array.from(
                                    new Set(
                                      retailerlist
                                        ?.filter((initem: any) =>
                                          initem?.item_groups?.some(
                                            (subitem: any) =>
                                              subitem?.item_data?.length > 0
                                          )
                                        )
                                        .flatMap((entry: any) =>
                                          entry.item_groups.map(
                                            (group: any) => group?.item_group
                                          )
                                        )
                                    )
                                  ).map((_, index) => {
                                    const groupTotal = calculateTotalRow(
                                      Array.from(
                                        new Set(
                                          retailerlist
                                            ?.filter((initem: any) =>
                                              initem?.item_groups?.some(
                                                (subitem: any) =>
                                                  subitem?.item_data?.length > 0
                                              )
                                            )
                                            .flatMap((entry: any) =>
                                              entry.item_groups.map(
                                                (group: any) => group.item_group
                                              )
                                            )
                                        )
                                      ),
                                      retailerlist?.filter((initem: any) =>
                                        initem?.item_groups?.some(
                                          (subitem: any) =>
                                            subitem?.item_data?.length > 0
                                        )
                                      ),
                                      getUnitTypes(retailerlist)
                                    ).item_group[index];

                                    return (
                                      <>
                                        {unitArrayType[index].unitTypes.map(
                                          (unit: string, unitindex: number) => (
                                            <>
                                              <td
                                                key={`${unit}-total-${
                                                  unitindex + 1
                                                }`}
                                                style={{ textAlign: "end" }}
                                              >
                                                {groupTotal.qty[unit]?.toFixed(
                                                  2
                                                )}
                                              </td>
                                              {/* <td
                                            key={`${unit}-total`}
                                            style={{ textAlign: "end" }}
                                          >
                                            {groupTotal.amt[unit]?.toFixed(2)}
                                          </td> */}
                                            </>
                                          )
                                        )}
                                        {/* <td style={{ textAlign: "end" }}>
                                      {(
                                        groupTotal.amt.KG +
                                        groupTotal.amt.PACKET +
                                        groupTotal.amt.BANDHA
                                      )?.toFixed(2)}
                                    </td> */}
                                      </>
                                    );
                                  })}
                                </tr>
                              </tbody>
                            </table>
                          );
                        }
                      )
                    ) : (
                      <>
                        <AlertBox style={{ justifyContent: "center" }} />
                      </>
                    )}
                  </GridLayoutItem>
                </GridLayout>
              </FormElement>
            );
          }}
        />
      ) : (
        <AlertBox />
      )}
    </>
  );
};

export default Top10RetailerReport;
